import {Box, Button, makeStyles} from "@material-ui/core";
import {useState} from "react";
import placeholder from '../images/placeholder.png';

const useStyles = makeStyles(() => ({
    uploadBox: {
        border: '1px solid rgba(0,0,0,0.2)',
        height: '113px',
        margin: '8px 0',
        padding: '18.5px 14px',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    previewImage: {
        height: '100px',
        width: 'auto',
        borderRadius: '4px'
    }
}));
export default function LogoUpload({defaultImage, onChange}) {
    const classes = useStyles();

    const [{alt, src}, setImg] = useState({
        src: defaultImage !== null ? defaultImage : placeholder,
        alt: 'Upload an Image'
    });

    const handleImg = (e) => {
        if (e.target.files[0]) {
            setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
        }
        onChange(e.target?.files[0]);
    }
    return (
        <Box className={classes.uploadBox}>
            <input
                accept="image/*"
                style={{display: 'none'}} id="contained-button-file"
                onChange={handleImg}
                type="file"
            />
            <label htmlFor="contained-button-file">
                <p style={{marginTop: 0, color: 'rgba(0,0,0,.5)'}}>Upload logo</p>
                <Button variant="contained" disableElevation component="span">
                    Choose file
                </Button>
            </label>
            <div style={{flex: '1'}}/>
            <img src={src} className={classes.previewImage} alt={alt}/>
        </Box>
    );

}